import { SubjectDetailsPageContent } from "@app/grades/pages";
import { getSubjectService } from "@core/grades/services";
import { type SubjectWithLessons } from "@core/grades/types";
import { getRootSettings, pageHead } from "@framework/config/drivers/meta";
import { publicRoutes } from "@framework/middleware";
import { plainTrans } from "@mongez/localization";
import { type MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";

export const loader = publicRoutes(async ({ params, http, success }) => {
  const { subject } = await getSubjectService(http, params.id!);

  return success({ subject });
});

export default function SubjectDetails() {
  const { subject } = useLoaderData<{ subject: SubjectWithLessons }>();

  return <SubjectDetailsPageContent subject={subject} />;
}

export const meta: MetaFunction<typeof loader> = ({ data, matches }) => {
  const settings = getRootSettings(matches);
  const { subject } = (data ?? {}) as { subject?: SubjectWithLessons };

  return pageHead({
    title: `${subject?.name || plainTrans("grades.subject")} - ${settings.general?.appName || ""}`,
    description:
      subject?.description ||
      plainTrans("grades.subjectDescription", { subject: subject?.name || "" }),
    image: subject?.image?.url || settings.general?.logo?.url || "",
    settings,
  });
};
